import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { isEmpty } from '../../../utilities/common';
import { isValidPhoneNANP } from '../patient-story-utilities';
const hfcLogo = `${import.meta.env.BASE_URL}hfc_logo_dark_blue.png`;

export default function PatientStoryContactForm({
  formData,
  setFormData,
  formErrors,
  showFormErrors
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const formatPhone = e => {
    const digits = e.target.value.replace(/\D/g, '');
    const match = digits.match(/^1?([2-9]\d{2})([2-9]\d{2})(\d{4})$/);
    if (match) {
      setFormData({
        ...formData,
        phone: `(${match[1]}) ${match[2]}-${match[3]}`
      });
    }
  };

  return (
    <div className="demographic-form">
      <div className="text-center mb-4">
        <img src={hfcLogo} alt="HFC Logo" style={{ maxHeight: '80px' }} />
      </div>
      <h2 className="text-center mb-4">I Want to Share My HFC Fertility Story</h2>

      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Label className="required">First Name</Form.Label>
          {!isEmpty(formErrors?.name_first) && (
            <span className="error-field">Required field</span>
          )}
          <Form.Control
            required
            type="text"
            name="name_first"
            maxLength={20}
            value={formData.name_first ?? ''}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label className="required">Last Name</Form.Label>
          {!isEmpty(formErrors?.name_last) && (
            <span className="error-field">Required field</span>
          )}
          <Form.Control
            required
            type="text"
            name="name_last"
            maxLength={20}
            value={formData.name_last ?? ''}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label className="required">Phone Number</Form.Label>
        {!isEmpty(formErrors?.phone) && (
          <span className="error-field">Required field</span>
        )}
        <Form.Control
          required
          type="tel"
          name="phone"
          inputMode="tel"
          autoComplete="tel"
          value={formData.phone ?? ''}
          onChange={handleChange}
          onBlur={formatPhone}
          pattern="^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$"
          title="Enter a valid 10-digit phone number, e.g. (416) 555-1234"
          isInvalid={showFormErrors && !isValidPhoneNANP(formData.phone)}
          onKeyPress={e => /[\d()+\s-]/.test(e.key) || e.preventDefault()}
        />
        <Form.Control.Feedback type="invalid">
          Please enter a valid 10-digit North American phone number.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Email</Form.Label>
        <Form.Control
          required
          type="email"
          name="email"
          value={formData.email ?? ''}
          onChange={handleChange}
          isInvalid={
            showFormErrors &&
            !formData?.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
          }
        />
        <Form.Control.Feedback type="invalid">
          Please enter a valid email address.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">
          Do you want us to contact you?
        </Form.Label>
        <div>
          <Form.Check
            required
            inline
            id="patient-story-want-contact-yes"
            type="radio"
            label="Yes"
            name="want_contact"
            value="Yes"
            checked={formData.want_contact === 'Yes'}
            onChange={handleChange}
            isInvalid={showFormErrors && !formData.want_contact}
          />
          <Form.Check
            required
            inline
            id="patient-story-want-contact-no"
            type="radio"
            label="No"
            name="want_contact"
            value="No"
            checked={formData.want_contact === 'No'}
            onChange={handleChange}
            isInvalid={showFormErrors && !formData.want_contact}
          />
        </div>
      </Form.Group>
    </div>
  );
}
